import { AlertTriangle, XCircle, X } from "lucide-react";
import { useState } from "react";
import { useSubscriptionStatus } from "../../hooks/use-subscription-status";
import { Alert, AlertDescription, AlertTitle } from "@/modules/shared/ui/components/alert";
import { Button } from "@/modules/shared/ui/components/custom/button";

export function SubscriptionStatusBanner() {
  const { data: status, isLoading } = useSubscriptionStatus();
  const [dismissed, setDismissed] = useState(false);

  if (isLoading || !status || dismissed) return null;

  if (status.isInGracePeriod) {
    const daysLeft = status.gracePeriodEnd
      ? Math.ceil(
          (new Date(status.gracePeriodEnd).getTime() - Date.now()) / (1000 * 60 * 60 * 24)
        )
      : 0;

    return (
      <Alert className="rounded-none border-l-4 border-yellow-500 bg-yellow-50 text-yellow-900">
        <AlertTriangle className="h-5 w-5 text-yellow-600" />
        <AlertTitle className="text-yellow-900 font-semibold">
          Payment Failed - Account will be suspended in {daysLeft} day{daysLeft !== 1 ? "s" : ""}
        </AlertTitle>
        <AlertDescription className="text-yellow-800">
          Please update your payment method to avoid service interruption.
        </AlertDescription>
        <div className="flex items-center gap-4 mt-3">
          <Button
            variant="outline"
            size="sm"
            className="bg-yellow-100 text-yellow-900 hover:bg-yellow-200 border-yellow-300"
            asChild
          >
            <a href="/billing">Update Payment Method</a>
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="text-yellow-600 hover:text-yellow-700 hover:bg-yellow-100"
            onClick={() => setDismissed(true)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </Alert>
    );
  }

  if (status.status === "PastDue" && status.organizationStatus === "Inactive") {
    return (
      <Alert className="rounded-none border-l-4 border-red-600 bg-red-50 text-red-900">
        <XCircle className="h-5 w-5 text-red-600" />
        <AlertTitle className="text-red-900 font-semibold">Account Suspended</AlertTitle>
        <AlertDescription className="text-red-800">
          Your account has been suspended. Update your payment method to restore access.
        </AlertDescription>
        <Button
          variant="outline"
          size="sm"
          className="mt-3 bg-red-100 text-red-900 hover:bg-red-200 border-red-300"
          asChild
        >
          <a href="/billing">Update Payment Method</a>
        </Button>
      </Alert>
    );
  }

  return null;
}